import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import sellSteps from "./sellSteps";

const StepBuy_1 = () => {
  const { goToStep } = useWizard();

  const handleYesStep = () => {
    return goToStep(sellSteps.knowPrice.step_1);
  };

  const handleNoStep = () => {
    return goToStep(sellSteps.doNotKnowPrice.step_1);
  };

  return (
    <BaseStep
      text="Вы знаете желаемую цену для продажи?"
      yesStep={handleYesStep}
      noStep={handleNoStep}
    />
  );
};

export default StepBuy_1;
